import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ApiConfig } from '~shared/constants/api.config';
import { Country } from '~shared/models';
import { HttpCrudService } from './http-crud.service';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { CountryCode } from '~shared/constants';

interface CountryStatic {
  name: string;
  iso2: string;
  code: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountriesService extends HttpCrudService {
  private isDataFetched = false;
  private readonly countryCodes : string[] = ['es', 'pt', 'it', 'de', 'pt', 'fr']

  public get countries$(): Observable<Country[]> {
    if (!this.isDataFetched) {
      this.fetch().pipe(
        tap(() => {
          this.isDataFetched = true;
        }),
      );
    }

    return this.data$;
  }

  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any
  ) {
    super(httpClient);
  }

  public read(): Observable<Country[]> {
     return this.getCountriesFromStaticFile();
  }

  private getStaticCountriesCDN(market: CountryCode) : string {
    const cdnUrl: string = ApiConfig.CDN_JSON_URL();
    if(this.countryCodes.includes(market)){
      return `${cdnUrl}/countries-${market}.json`
    }
    return `${cdnUrl}/countries.json`
  }

  private getCountriesFromStaticFile(): Observable<Country[]> {
    const market: CountryCode = getCountryDomainCode(this.webAppBuyerRequest);
    const url: string = this.getStaticCountriesCDN(market);
    return this.request({url})
      .pipe(
        map((countries: CountryStatic[]) => {
          return countries.map(country => {
            const {name, iso2, code} = country;
            return {name, id: iso2, code, default: iso2 === market} as Country
          }).sort((a,b) => a.name.localeCompare(b.name))
        })
      );
  }
}
